import React, { useEffect, useState } from 'react'
import CustomModal from '../../components/ReactModal'
import Modal from '../../components/Modal'
import { userService, bankService, subscriptionService } from '../../_services'
import { toast } from 'react-toastify'
import { saveData } from '../../_helpers'
import { useHistory } from 'react-router-dom'



import { Card } from './Card'
import { BankAccountCard } from './BankAccountCard'
import { BankForm } from './BankForm'
import { AddBankCardForm } from './AddBankCardForm'
import BankVerification from './BankAccountVerification'



function PaymentMethodView({selectedPlan, setSelectedPlan, subscriptionInfo, setSubscriptionInfo}) {

    const history = useHistory()

    const bankSources = process.env.REACT_APP_BANK_SOURCES == 'true'

    const [addedAccount, setAddedAccount] = useState([])
    const [cardList, setCardList] = useState([])
    // const [subscriptionInfo, setSubscriptionInfo] = useState(null)
    const [bankListRefreshkey, setbankListRefreshkey] = useState(0)
    const [addPayout, setAddPayout] = useState(false)
    const [addCard, setAddCard] = useState(false)
    const [host, setDetail] = useState({})
    const [refreshKey, setRefreshKey] = useState(0)
    const [suspense, setSuspense] = useState(true)
    const [isStripeVerified, setIsStripeVerified] = useState(false)
    const [stripeAllAccountDetails, setStripeAllAccountDetails] = useState({})
    const [addBankAccountEnabled, setAddBankAccountEnabled] = useState(false)
    const [currentStripeStatus, setCurrentStripeStatus] = useState(false)
    const [showUpdateVerificationDetailButton, setShowUpdateVerificationDetailButton] = useState(false)
    const [isLoading, setIsLoading] = useState(false) 

    
    const subscribe = async () => {
        setIsLoading(true)
        let res = null
        try {
            if(subscriptionInfo.status != 'Cancelled' && subscriptionInfo.planId && subscriptionInfo.planId != 'grandfathered' && subscriptionInfo.planId != 'none' && selectedPlan != subscriptionInfo.planId) {
                res = await subscriptionService.updateSubscription(selectedPlan, 'upcoming')
            } else {
                res = await subscriptionService.subscribe(selectedPlan)
            }
            console.log("subscribe res", res)
            if(res && res.status) {
                setSubscriptionInfo(res.data)
                setSelectedPlan(null)
                if(res.message) {
                    toast.success(res.message)
                }
            } else {
                if(res?.message) {
                    toast.error(res.message)
                }
            }
        } catch (error) {
            toast.error('Subscription failed.')
        } finally {
            setIsLoading(false)
        }
    }

    const fetchUserDetail = () => {
        userService.getDetail({}).then(objS => {
            if (objS.status) {
                setDetail(objS.data)
            }
        })
    }

    useEffect(() => {
        if (refreshKey !== 0) {
            fetchUserDetail()
        }
    }, [refreshKey])

    useEffect(() => {
        fetchUserDetail()
    }, [])

    useEffect(() => {
        const fetchStripeDetail = async () => {
            await bankService.getStripeDetail().then(async res => {
                if (res.data.business_type !== null) {
                    const accountTypeIndividual = res.data.business_type === 'individual' ? true : false
                    const verficationStatus = accountTypeIndividual ? res.data.individual.verification.status : res.data.company.verification.status
                    setCurrentStripeStatus(verficationStatus)
                }
                const status = res.data.charges_enabled && res.data.payouts_enabled
                setIsStripeVerified(status)
                setStripeAllAccountDetails(res.data)

                const stripeDetails = res.data
                if (stripeDetails) {
                    if (stripeDetails.requirements) {
                        const currently_due = stripeDetails.requirements.currently_due.filter(item => item !== 'external_account')

                        if (currently_due.length > 0 && stripeDetails.business_type) {
                            setShowUpdateVerificationDetailButton(true)
                        }
                    }
                }

                setSuspense(false)
            })
        }
        fetchStripeDetail()
    }, [])

    useEffect(() => {
        const enabled = stripeAllAccountDetails.business_type !== null &&
            stripeAllAccountDetails.charges_enabled === true &&
            stripeAllAccountDetails.payouts_enabled === true

        setAddBankAccountEnabled(enabled)
    }, [stripeAllAccountDetails])

    useEffect(() => {
        const fetchAccountList = async () => {
            setIsLoading(true)
            try {
                const res = await subscriptionService.getSources(true)
                console.log('res', res)
                if (res.status) {
                    setAddedAccount(res.data?.bankAccounts?.data)
                    setCardList(res.data?.cardlist?.data)
                    setSubscriptionInfo(res.data?.subscription)
                } else {
                    toast.error(res.message)
                    setAddedAccount([])
                    setCardList([])
                    // setSubscriptionInfo(null)
                }
            } catch (error) {
                toast.error('Something went wrong')
            } finally {
                setIsLoading(false)
            }
        }

        fetchAccountList()
    }, [bankListRefreshkey])

    const toggleAddPayout = () => {
        setAddPayout(e => !e)
    }

    const saveBankAccount = (accountForm, setRequesting) => {
        accountForm.accountHolderName = accountForm.accountHolderName.trim()
        accountForm.accountNumber = accountForm.accountNumber.trim()
        accountForm.confirmAccountNumber = accountForm.confirmAccountNumber.trim()
        accountForm.routingNumber = accountForm.routingNumber.trim()
        if (accountForm.accountNumber != accountForm.confirmAccountNumber) {
            toast.info('Account number and confirm account number must be same.')
            return
        }
        setRequesting(true) 
        var postObj = { hostId: host.id, isPayment: true, ...accountForm }

        bankService.addBank(postObj).then(
            objS => {
                if (objS.status) {
                    setbankListRefreshkey(e => e + 1)
                    host.payoutVerification = true
                    saveData(host)
                    setAddPayout(false)
                    toast.success('Bank account added successfully')
                    setRefreshKey(oldKey => oldKey + 1)
                } else {
                    toast.error(objS.message)
                }
                setRefreshKey(e => e + 1)
                setRequesting(false)
            },
            error => {
                setRequesting(false)
                toast.error('An error occurred while adding the bank account.')
            }
        )
    }

    const handleDelete = async id => {
        setIsLoading(true)
        try {
            const res = await subscriptionService.handleDeleteBank(id)

            if (res.status) {
                toast.success(res.message)
                setAddedAccount(el => el.filter(curr => curr.id !== id))
                setbankListRefreshkey(oldKey => oldKey + 1)
            } else toast.error(res.message)
        } catch (error) {
            toast.error('Something went wrong!')
        } finally {
            setIsLoading(false)
        }
    }

    

    return (
        <>
        <div className="tw-flex tw-flex-col tw-w-full tw-rounded-2xl tw-px-5 tw-py-5 tw-border-solid tw-border tw-border-[#C7C7C7] tw-mt-8">
            <div className="tw-flex tw-items-center tw-justify-between"> {/* 💡 Зміни тут для Loading */}
                 <div>
                    Payment Method
                 </div>
                 {isLoading && (
                    <div className="tw-flex tw-items-center tw-text-sm tw-text-[#94BA33] tw-font-semibold">
                        <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                        Processing...
                    </div>
                 )}
            </div>
            {suspense ? (
                <div className="tw-flex">
                    <p className="tw-text-center tw-py-4">Loading...</p>
                </div>
            ) : (
                <div className='tw-flex tw-w-full'>
                    <div className='tw-flex tw-flex-col tw-w-full'>
                        <div className='tw-flex tw-flex-row tw-gap-2'>
                            {bankSources && <button disabled={!addBankAccountEnabled || isLoading} type='button' onClick={() => setAddPayout(!addPayout)} className="btn btn-primary btn-sm tw-w-max mt-4">
                                {/* Add bank account */}
                                Add Bank Account
                            </button>}
                            <button type='button' disabled={isLoading} onClick={() => setAddCard(!addCard)} className="btn btn-primary btn-sm tw-w-max mt-4">
                                {/* Add bank account */}
                                Add Credit Card
                            </button>
                        </div>
                        {bankSources && !addBankAccountEnabled && <p className="tw-text-sm tw-text-gray-400 tw-mt-1">
                            ⓘ To add a bank account, complete verification on the payment method page.
                        </p>}
                       
                        
                            <div className="tw-grid md:tw-grid-cols-2 xl:tw-grid-cols-3 tw-gap-6 tw-mt-4">
                            {bankSources && subscriptionInfo && addedAccount.map(account => (
                                <BankAccountCard
                                    isLast={addedAccount.length === 1}
                                    setbankListRefreshkey={setbankListRefreshkey}
                                    setSubscriptionInfo={setSubscriptionInfo}
                                    handleDelete={handleDelete}
                                    accountData={account}
                                    key={account.id}
                                    primaryId={subscriptionInfo?.primaryMethod}
                                    selectedText={'Selected'}
                                    selectedStyle={`tw-mb-4 tw-p-4 tw-rounded tw-ring-1 tw-flex tw-gap-y-2 tw-flex-col tw-items-start tw-justify-between md:tw-flex-row tw-text-gray-600 tw-ring-[#94BA33]`}
                                    selectedViewStyle={`tw-capitalize tw-bg-[#94BA33] tw-w-max tw-text-white tw-text-xs tw-p-1 tw-rounded`}
                                    selectButtonStyle={'tw-py-1 tw-bg-[#AAAAAA] tw-h-fit tw-w-max tw-text-sm tw-px-2 tw-cursor-pointer tw-rounded tw-text-white tw-border'}
                                
                                />
                            ))}
                            {subscriptionInfo && cardList.map((curr) => {
                                return <Card key={curr.id} subscriptionInfo={subscriptionInfo} setSubscriptionInfo={setSubscriptionInfo} setRefreshKey={(e) => {
                                        setRefreshKey(e)
                                        setbankListRefreshkey(e)
                                    }} data={curr} primaryId={subscriptionInfo?.primaryMethod}
                                    selectedText={'Selected'}
                                    selectedStyle={`tw-mb-4 tw-p-4 tw-rounded tw-ring-1 tw-flex tw-gap-y-2 tw-flex-col tw-items-start tw-justify-between tw-text-gray-600 ${subscriptionInfo?.updatePaymentMethodRequired ? 'tw-ring-[#FF0000]' : 'tw-ring-[#94BA33]'}`}
                                    selectedViewStyle={`tw-capitalize tw-bg-[#94BA33] tw-w-max tw-text-white tw-text-xs tw-p-1 tw-rounded`}
                                    selectButtonStyle={'tw-py-1 tw-bg-[#AAAAAA] tw-h-fit tw-w-max tw-text-sm tw-px-2 tw-cursor-pointer tw-rounded tw-text-white tw-border'}
                                />
                            })}
                            </div>
                            
                            <button 
                            disabled={selectedPlan == null || subscriptionInfo == null || subscriptionInfo?.primaryMethod == null || isLoading} 
                            type='button' 
                            onClick={subscribe} 
                            className='btn btn-primary btn-sm tw-w-min tw-border-none tw-bg-[#94BA33] tw-text-white tw-py-2 tw-px-4 tw-rounded-2xl'
                            >
                                Subscribe
                            </button>
                        
                    </div>  
                    {addPayout && (
                        <CustomModal>
                            <div className='tw-flex tw-w-full tw-justify-center'>
                             <BankVerification onVerificationComplete={() => {
                                 setbankListRefreshkey(e => e + 1)
                             }} onClose={() => {
                                 setAddPayout(false)
                             }}/>
                             </div>
                            {/* <BankForm onSubmit={saveBankAccount} onClose={toggleAddPayout} /> */}
                        </CustomModal>
                    )}
                    {addCard && (
                        <Modal backgroundColor={'tw-bg-[rgba(0,0,0,0.884)]'} className="tw-rounded-2xl tw-w-full lg:tw-w-8/12 tw-mx-auto">
                            <AddBankCardForm onClose={() => {setAddCard(false)}} setRefreshKey={(e) => {
                                setRefreshKey(e)
                                setbankListRefreshkey(e)
                            }}/>
                        </Modal>
                    )}
                </div>
            )}
            </div>
        </>
    )
}

export default PaymentMethodView